export default class Banner {
  constructor(t, i, s, h = !1, r = !1, e = -1) {
    (this.id = t),
      (this.placementId = i),
      (this.html = s),
      (this.At = h),
      (this.isControl = r),
      (this.Gt = e),
      (this.id = t),
      (this.placementId = i),
      (this.html = s),
      (this.At = h),
      (this.isControl = r),
      (this.Gt = e),
      (this.Ht = !1);
  }
  Jt() {
    return this.isControl;
  }
  bt() {
    return {
      id: this.id,
      o: this.placementId,
      html: this.html,
      t: this.At,
      i: this.isControl,
      u: this.Gt,
    };
  }
}
